import axios from 'axios';

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_URL}/api`;

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await axios.post(`${API}/upload`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
};

export const getFileUrl = (fileId) => {
  const token = localStorage.getItem('token');
  return `${API}/files/${fileId}${token ? `?auth=${token}` : ''}`;
};